import axios from "axios";
import { store } from "@/store.js";

const storeID = store;

export default {
    apiServiceCall(type, id, url, data, headers) {
        if (storeID.sessionID == "") {
            storeID.sessionID = window.localStorage.getItem("token");
        }

        axios.defaults.headers.common["Authorization"] = "Bearer " + storeID.sessionID;
        if (type == "Get") {
            return axios.get(url, headers);
        } else if (type == "GetOne") {
            return axios.get(url + id + "/", headers);
        } else if (type == "Post") {
            return axios.post(url, data, headers);
        } else if (type == "Update") {
            return axios.put(url, data, headers);
        } else if (type == "Delete") {
            return axios.delete(url + id, headers);
        }
    },
};
